import type { DashboardWidget } from "@/contexts/DashboardEditContext";

export type DashboardStyle = "minimal" | "executive" | "command";

export interface DashboardLayoutResponse {
  widgets: DashboardWidget[];
  style?: DashboardStyle;
}

export interface DashboardLayoutSaveRequest {
  widgets: DashboardWidget[];
  style?: DashboardStyle;
}

const BASE = "/api/v1/dashboard";

async function request<T>(url: string, init?: RequestInit): Promise<T> {
  const res = await fetch(url, {
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    ...init,
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ detail: res.statusText }));
    throw new Error((err as { detail?: string }).detail ?? res.statusText);
  }
  return res.json();
}

export const dashboardService = {
  getLayout: (): Promise<DashboardLayoutResponse> =>
    request<DashboardLayoutResponse>(`${BASE}/layout`),

  saveLayout: (payload: DashboardLayoutSaveRequest): Promise<DashboardLayoutResponse> =>
    request<DashboardLayoutResponse>(`${BASE}/layout`, {
      method: "PUT",
      body: JSON.stringify(payload),
    }),
};
